import { render, staticRenderFns } from "./OrganizationInvoices.vue?vue&type=template&id=217802d0"
import script from "./OrganizationInvoices.vue?vue&type=script&lang=js"
export * from "./OrganizationInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports